import * as types from '../actions/actionTypes'

const initialState = {
    isLoading: false,
    eveniments: []
}

export default function evenimentsReducer(state = initialState, action) {
    switch (action.type) {
        case types.EVENIMENTS_IS_LOADING:
            return Object.assign({}, state, {
                isLoading: true
            })

        case types.EVENIMENTS_FETCH:
            return Object.assign({}, state, {
                eveniments: action.payload
            }) 

        case types.EVENIMENTS_ADD:
            return Object.assign({}, state, {
                eveniments: state.eveniments.concat(action.payload)
            })

        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/store/reducers/evenimentsReducer.js